export default __webpack_public_path__ + "static/media/SymbolBold.2f6ef6b4.otf";